// extracted by mini-css-extract-plugin
export var borderRadius = "_ab-4";
export var large = "_ab-3";
export var logoContainer = "_ab-0";
export var nameLogo = "_ab-2";
export var small = "_ab-1";